import {
    LoadingArticleItemTitle,
    LoadingStyledIntro,
    LoadingItemHero
} from "../../../utils/loading-styles";

export const LoadingArticleItem = () => {

    return (
        <>
            <LoadingItemHero>
                &nbsp;
            </LoadingItemHero>

            <LoadingArticleItemTitle><h2>&nbsp;</h2></LoadingArticleItemTitle>
            <LoadingStyledIntro>
            <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
            </LoadingStyledIntro>
        </>
    );
}
